import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Inter, self-hosted (ADR-0003) — the vendored Nocturne sheet's CDN @import was removed.
// Weight 400 for body, 500 for headings; the system never goes bolder than 500.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';

import '../styles/nocturne.css';
import './global.css';
import { App } from './App';

const container = document.getElementById('root');
if (container === null) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
